import { useEffect, useState } from "react";
import axios from "axios";
import { useDataContext } from "../Context/dataContext";

function useFetchAllMovements(accessToken) {
  const { url } = useDataContext();
  const [movements, setUserMovements] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!accessToken || !url) return;
    setLoading(true);
    setError(null);

    const fetchDataMovements = async () => {
      try {
        const response = await axios.get(`${url}/Movements`, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        });
        setUserMovements(response.data);
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    };

    fetchDataMovements();
  }, [accessToken, url]);

  return { movements, loading, error };
}

export { useFetchAllMovements };